import { render } from "./swift.vue?vue&type=template&id=13583527&scoped=true&ts=true"
import script from "./swift.vue?vue&type=script&lang=ts"
export * from "./swift.vue?vue&type=script&lang=ts"

import "./swift.vue?vue&type=style&index=0&id=13583527&lang=less&scoped=true"
import "./swift.vue?vue&type=style&index=1&id=13583527&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13583527"]])

export default __exports__